var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z",
    fill: "#AE9D9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04702 8.5C6.49702 8.5 6.04698 8.09353 6.04698 7.59676V3.17617C6.04698 2.6794 6.49702 2.27295 7.04702 2.27295C7.59702 2.27295 8.04698 2.6794 8.04698 3.17617V7.59676C8.04698 8.09353 7.59702 8.5 7.04702 8.5Z",
    fill: "#FDFEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99974 12C6.44745 12 5.99974 11.5523 5.99974 11C5.99974 10.4477 6.44745 10 6.99974 10C7.55198 10 7.99974 10.4477 7.99974 11C7.99974 11.5523 7.55198 12 6.99974 12Z",
    fill: "#FDFEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.c3b1457ebb5a226b90385c97590da7b3.svg";
export { ForwardRef as ReactComponent };